const root = function* () {};

export default root;
